/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import React from 'react';
import PropTypes from 'prop-types';
import ExtensionDisplay from './ExtensionDisplay';
import classNames from 'classnames';
import { objectToArray } from '../utils/common.js';

const renderExtensions = (extensions, falsifyUndefined = false) => {
  return objectToArray(extensions).map((extension) => {
    // Hack here because "false" the string is being evaluated as false;
    // turn it back into a string, and fix it in ExtensionDisplay.js
    // Could potentially rewrite objectToArray in common.js to handle
    // this better, but would impact all the other calls to that code
    if (falsifyUndefined && !extension.value) extension.value = 'false';
    return <ExtensionDisplay key={extension.key} extensionName={extension.key} extensionBody={extension.value} />;
  });
};

const ExtensionsDisplay = ({ label, className, extensions }) => {
  // If there is no label, don't render in left/right column split mode
  if (!label || label === '') {
    return <div className="valueText">{renderExtensions(extensions)}</div>;
  } else {
    return (
      <div className={classNames('operationInformation extensions', className)} data-testid={'extensions-split'}>
        {label && <div className="labelText">{label}</div>}
        <div className="valueText">{renderExtensions(extensions, true)}</div>
      </div>
    );
  }
};

ExtensionsDisplay.propTypes = {
  label: PropTypes.string, // The label text to display
  className: PropTypes.string, // The CSS class name to use
  extensions: PropTypes.object // The info Extension object
};

export default ExtensionsDisplay;
